import React, { useEffect, useState } from "react";
import ViewMoreBtn from "../../components/ViewMoreBtn";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { arrowRight } from "../../../../assets/svg/Svg";
import { NotePencil, Trash } from "@phosphor-icons/react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as cartSlice from "../../../../redux/slices/cartSlice"; // Import the cartSlice
import moment from "moment";
import DeleteModal from "../../components/DeleteModal";
import * as customizeSlice from "../../../../redux/slices/customizeSlice";
import CustomizeCartDetails from "./CustomizeCartDetails";

const CustomizeCartList = () => {
  const [data, setData] = useState([]);
  const [deletableId, setDeletableId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [viewModal, setViewModal] = useState(false);
  const [selectedCart, setSelectedCart] = useState(null);

  const { loading, allCartList } = useSelector((state) => state.customizeSlice); // Updated to cartSlice

  // Fetch cart list on component mount
  useEffect(() => {
    dispatch(customizeSlice.getCartList());
  }, [dispatch]);

  const handleViewUser = (data) => {
    setSelectedCart(data);
    setViewModal(true);
  };

  // Update data when cartList changes
  useEffect(() => {
    if (allCartList && allCartList.length > 0) {
      setData(allCartList);
    } else {
      setData([]);
    }
  }, [allCartList]);

  const columns = [
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => moment(row.created_at).format('DD/MM/YYYY HH:mm'),
      sortable: true,
    },
    {
      name: "Trip Name",
      selector: (row) => row?.trip_name, // Assuming cart item has a 'trip_name' field
      sortable: true,
    },
    {
      name: "Payment Status",
      selector: (row) => (row?.payment_status === 1 ? "Success" : "Pending"), // Assuming cart item has a 'trip_name' field
      sortable: true,
    },
    {
      name: "Trip Status",
      selector: (row) => {
        switch (row?.status) {
          case 0:
            return "Pending";
          case 1:
            return "Completed";
          case 2:
            return "Cancelled";
          case 3:
            return "Upcoming";
          default:
            return "Unknown";
        }
      },
      sortable: true,
    },

    {
      name: "Start Date",
      selector: (row) => moment(new Date(row?.start_date)).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => moment(new Date(row?.end_date)).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex table_action">
          {/* <div className="edit" onClick={() => navigate(`/cart/edit/${row.id}`)}>
            <NotePencil size={18} />
          </div>
          <div className="delete">
            <Trash onClick={() => {
              setDeleteModal(true);
              setDeletableId(row.id);
            }} size={19} />
          </div> */}
          {/* <div className="view_more">
            <ViewMoreBtn redirectUrl={`/cart/details/${row.id}`} />
          </div> */}
          <div
            className="view_more"
            onClick={() => navigate(`/customize-cart/${row?.id}`)}
          >
            <ViewMoreBtn />
          </div>
        </div>
      ),
    },
  ];

  const handleDeleteUser = () => {
    // Implement delete logic here
    // dispatch(cartSlice.deleteCartItem(deletableId, setDeletableId, setDeleteModal));
  };

  const filteredData = data.filter(
    (item) =>
      item.trip_name.toLowerCase().includes(searchText.toLowerCase()) ||
      item.id.toString() === searchText // Ensure id is compared as string
  );

  const handleSearch = (value) => {
    setSearchText(value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const paginationOptions = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "All",
  };

  const paginationPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * paginationPerPage,
    currentPage * paginationPerPage
  );

  const customPagination = () => {
    const page = Math.ceil(filteredData.length / paginationPerPage);
    const pageButtons = [];
    const startPage = Math.max(currentPage - 1, 1);
    const endPage = Math.min(currentPage + 1, page);

    // Always add the first page
    pageButtons.push(
      <button
        key={1}
        className={`btn-pagination ${currentPage === 1 ? "active" : ""}`}
        onClick={() => setCurrentPage(1)}
      >
        1
      </button>
    );

    // Ellipsis after the first page if necessary
    if (startPage > 2) {
      pageButtons.push(
        <span key="ellipsis-start" className="pagination-ellipsis">
          &hellip;
        </span>
      );
    }

    // Range of buttons around the current page
    for (let i = startPage; i <= endPage; i++) {
      if (i !== 1 && i !== page) {
        pageButtons.push(
          <button
            key={i}
            className={`btn-pagination ${currentPage === i ? "active" : ""}`}
            onClick={() => setCurrentPage(i)}
          >
            {i}
          </button>
        );
      }
    }

    // Ellipsis before the last page if necessary
    if (endPage < page - 1) {
      pageButtons.push(
        <span key="ellipsis-end" className="pagination-ellipsis">
          &hellip;
        </span>
      );
    }

    // Always add the last page
    if (page !== 1) {
      pageButtons.push(
        <button
          key={page}
          className={`btn-pagination ${currentPage === page ? "active" : ""}`}
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </button>
      );
    }

    return (
      <div className="pagination-container mt-5">
        <button
          className="btn-pagination btn-pagi_prev"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {arrowRight}
        </button>
        <span>{pageButtons}</span>
        <button
          className="btn-pagination btn-pagi_next"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === page}
        >
          {arrowRight}
        </button>
      </div>
    );
  };
  const [paymentFilter, setPaymentFilter] = useState();
  const [finalData, setFinalData] = useState([]);
  return (
    <>
      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <>
          <div>
            <div className="page-header">
              <h3 className="page-title">Cart</h3>
            </div>
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <DataTable
                      title={<h6 className="card-title">Cart List</h6>}
                      columns={columns}
                      data={
                        paymentFilter
                          ? paginatedData?.filter(
                              (d) => d?.payment_status == paymentFilter
                            )
                          : paginatedData
                      }
                      pagination
                      paginationServer
                      paginationTotalRows={filteredData.length}
                      onChangePage={(page) => setCurrentPage(page)}
                      paginationComponentOptions={paginationOptions}
                      paginationComponent={customPagination}
                      highlightOnHover
                      pointerOnHover
                      subHeader
                      subHeaderAlign="left"
                      subHeaderComponent={
                        <Row className="mb-3">
                          <Col md={6}>
                          <label htmlFor="payment-status">
                              Search Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search by trip name"
                              value={searchText}
                              onChange={(e) => handleSearch(e.target.value)}
                            />
                          </Col>
                          <Col md={6}>
                            <label htmlFor="payment-status">
                              Payment Status
                            </label>
                            <select
                              id="payment-status"
                              className="form-control"
                              value={paymentFilter}
                              onChange={(e) => setPaymentFilter(e.target.value)}
                            >
                              <option value="">Select Payment Status</option>
                              <option value="1">Success</option>
                              <option value="0">Pending</option>
                            </select>
                          </Col>
                        </Row>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            handleDelete={handleDeleteUser}
            name={"Cart Item"}
          />
        </>
      )}
    </>
  );
};

export default CustomizeCartList;
